import { useEffect } from 'react'

export const useCartDrawerEffects = ({
  drawerOpen,
  closeDrawer,
}: {
  drawerOpen: boolean
  closeDrawer: () => void
}) => {
  useEffect(() => {
    if (!drawerOpen) {
      document.body.style.overflow = ''
      return
    }
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [drawerOpen])

  useEffect(() => {
    if (!drawerOpen) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') closeDrawer()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [closeDrawer, drawerOpen])
}
